// tailorSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Source from '../../Source';

// اکشن برای دریافت خیاط‌ها از API
export const getTailors = createAsyncThunk('tailors/getTailors', async () => {
  const response = await axios.get(`${Source.getAddress()}/api/tailor`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access")}`,
    },
  });
  console.log(response);
  return response.data;
});

// تعریف سلایس خیاط‌ها
const tailorSlice = createSlice({
  name: 'tailors',
  initialState: {
    tailors: [], // لیست خیاط‌ها
    loading: false, // وضعیت بارگذاری
    error: null, // خطا
    statusTailor: null, // وضعیت API
  },
  reducers: {
    // اکشن برای اضافه کردن خیاط جدید به کش
    addTailorToCache: (state, action) => {
      state.tailors.push(action.payload);
    },
    // اکشن برای به‌روزرسانی اطلاعات یک خیاط در کش
    updateTailorInCache: (state, action) => {
      const { updatedData } = action.payload;
      const index = state.tailors.findIndex((tailor) => tailor.id === updatedData.id);
      if (index !== -1) {
        state.tailors[index] = { ...state.tailors[index], ...updatedData };
      }
    },
    // اکشن برای حذف یک خیاط از کش
    deleteTailorFromCache: (state, action) => {
      const id = action.payload;
      state.tailors = state.tailors.filter((tailor) => tailor.id !== id);
    },
    // اکشن برای گرفتن یک خیاط خاص (اختیاری)
    getTailorFromCache: (state, action) => {
      const id = action.payload;
      return state.tailors.find((tailor) => tailor.id === id);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTailors.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.statusTailor = 'loading';
      })
      .addCase(getTailors.fulfilled, (state, action) => {
        state.loading = false;
        state.tailors = action.payload;
        state.statusTailor = 'succeeded';
      })
      .addCase(getTailors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.statusTailor = 'rejected';
      });
  },
});

// اکسپورت اکشن‌ها و ریدوسر
export const {
  addTailorToCache,
  updateTailorInCache,
  deleteTailorFromCache,
  getTailorFromCache,
} = tailorSlice.actions;

export default tailorSlice.reducer;
